import { Flex } from 'antd'
import { PropsWithChildren } from 'react'

const StepWrapper = ({ children }: PropsWithChildren) => {
  return (
    <Flex
      justify="center"
      align="center"
      style={{
        width: '100%',
        height: 'calc(100vh - 64px)',
      }}
    >
      <Flex
        justify="center"
        style={{
          width: '100%',
          maxHeight: 'calc(100vh - 64px)',
          overflow: 'scroll',
          padding: 10,
        }}
      >
        {children}
      </Flex>
    </Flex>
  )
}

export default StepWrapper
